import React from "react";
import { QRCodeCanvas } from 'qrcode.react';
import { useNavigate } from "react-router-dom";

const frontendBaseURL = process.env.REACT_APP_FRONTEND_BASE_URL || 'https://pro.lisual.com' ;

const QRModal = ( { isOpen, onClose, customerId, identifier } ) => {
const size = 220; // Tamaño ligeramente reducido para que encaje mejor en la columna
const url = `${frontendBaseURL}/camaraSetupWizard/${customerId}/${identifier}`;
const navigate = useNavigate();





const handleMobileContinue = () => {
    navigate(`/camaraSetupWizard/${customerId}/${identifier}`);
    
  };

if (!isOpen) return null;

  return (
   <div
      className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center p-4 z-50 transition-opacity duration-300"
      // Se utiliza `e.stopPropagation()` en el contenido para evitar que el clic cierre la modal
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div 
        className="relative bg-white rounded-xl w-full max-w-2xl shadow-2xl transform scale-100 transition-transform duration-300 max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()} // Evita que el clic en el contenido cierre la modal
      >
        {/* Header */}
        <div className="flex justify-between items-center p-5 border-b border-gray-100 bg-gray-50">
          <h2 className="text-xl font-semibold text-gray-800 flex items-center">
             📱 Asistente de Configuración de Cámara
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-700 transition duration-150 p-1 rounded-full hover:bg-gray-200"
            aria-label="Cerrar"
          >
            <span className="text-2xl leading-none">×</span>
          </button>
        </div>

        {/* Body & QR Section */}
        <div className="md:grid md:grid-cols-2">
            
            {/* Columna de Instrucciones y Botones */}
            <div className="p-6 flex flex-col justify-between">
                <div className="space-y-4">
                    <p className="text-lg font-medium text-gray-800">
                        ¿Cómo deseas continuar?
                    </p>
                    
                    {/* Instrucciones */}
                    <div className="space-y-3 text-gray-600">
                        <p className="flex items-start">
                            <span className="text-blue-500 mr-2 font-bold text-lg">1.</span>
                            Si ya estás en tu móvil, toca "Continuar" para comenzar.
                        </p>
                        <p className="flex items-start">
                            <span className="text-blue-500 mr-2 font-bold text-lg">2.</span>
                            Si estás en tu computadora, escanea el código QR con tu móvil.
                        </p>
                    </div>
                </div>

                {/* Área de Botones (Fondo de color diferente) */}
                <div className="mt-6 pt-4 border-t border-gray-100 flex flex-col sm:flex-row gap-3">
                    <button
                        onClick={onClose}
                        className="w-full sm:w-auto px-6 py-2 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-100 transition duration-150 shadow-sm"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleMobileContinue} // Usa la función correcta
                        className="w-full sm:w-auto px-6 py-2 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition duration-150 shadow-md flex-grow"
                    >
                        Estoy en mi móvil &rarr;
                    </button>
                </div>
            </div>


            {/* Columna del Código QR */}
            <div className="p-6 bg-blue-50 border-l border-gray-100 flex flex-col items-center justify-center">
                <div className="bg-white p-4 rounded-lg shadow-xl inline-block">
                    <QRCodeCanvas
                        value={url} 
                        size={size} 
                        level="H" 
                        imageSettings={{ // Opcional: añade un pequeño margen
                            src: "", // Podrías poner un logo aquí
                            height: 20,
                            width: 20,
                            excavate: true,
                        }}
                    />
                </div>
                <p className="mt-4 text-sm font-medium text-gray-600">
                    Escanea si estas desde la computadora.
                </p>
            </div>
            
        </div>
        
      </div>
    </div>
  );
}

export default QRModal;